import { useTranslation } from 'react-i18next'

import { Pagination } from "../../pagination"
import { useState } from 'react'
import FolderComponent from '../FolderComponent/FolderComponent'
import { FolderDetail } from '../../../../domain/Folder/Folder'
import Forms from '../../../../domain/Form/Forms'
import SortArrowUp from '../../svg/SortArrowUp'
import SortArrowDown from '../../svg/SortArrowDown'
import SortArrow from '../../svg/SortArrow'


interface Props {
  folders: FolderDetail[]
  totalItems: number
  itemsPerPage: number
  handleDeleteFolder: (id: string) => void
  type: string | null
  forms: Forms[]
  state: string | null
  sortConfig: { key: string, direction: 'asc' | 'desc' }
  requestSort: (key: string) => void
}

const FoldersDataListAsTable = ({ folders, totalItems, itemsPerPage, handleDeleteFolder, type, forms, state, requestSort, sortConfig }: Props): JSX.Element => {
  const { t } = useTranslation();

  return (
    <>
      <div className="table-wrapper">
        <div className="table-scroll">
          <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: '1200px' }}>
            <thead>
              <tr>
                <th>{t('table.header.id')}</th>
                <th
                  onClick={() => requestSort('created_at')}
                  style={{ cursor: 'pointer', userSelect: 'none' }}
                  title={t('table.sort.hint')}
                >
                  {t('table.header.date')}
                  <span style={{ marginLeft: '8px' }}>
                    {sortConfig?.key === 'created_at' ? (
                      sortConfig.direction === 'asc' ? SortArrowUp() : SortArrowDown()
                    ) : SortArrow()}
                  </span>
                </th>
                <th>{t('table.header.investor-name')}</th>
                <th>{t('table.header.scpi-name')}</th>
                <th>{t('table.header.partners')}</th>
                <th>{t('table.header.advisor-name')}</th>
                <th>{t('table.header.nature')}</th>
                <th style={{ textAlign: 'center' }}>{t('table.header.parts')}</th>
                <th style={{ textAlign: 'center' }}>{t('table.header.actions')}</th>
              </tr>
            </thead>
            <tbody>
              {folders?.map((folder) => (
                <FolderComponent
                  FolderDetail={folder}
                  key={folder.id}
                  forms={forms}
                  handleDeleteFolder={handleDeleteFolder}
                  type={type}
                  state={state}
                />
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <div className="box-elevations no-max-width border-top-0">
        <Pagination itemsPerPage={itemsPerPage} totalItems={totalItems} />
      </div>
    </>
  );
};

export default FoldersDataListAsTable;
